function setupActions(options) {
  var preventFeedback = false;
  var currentAction = null;

  function getNextAction(action) {
    if (options["skipLoggedOutShareSteps"]) {
      var nextAction = action ? action.next() : $('.raction:eq(0)');
      if (nextAction.attr('id') == 'rshare') {
        if (window.socialMediaStatuses.facebook === false &&
            window.socialMediaStatuses.twitter === false &&
            !isMobile()) {
          return getNextAction(nextAction);
        }
      }
      else if (nextAction.attr('id') == 'rfacebook') {
        if (window.socialMediaStatuses.facebook === false) {
          return getNextAction(nextAction);
        }
      }
      else if (nextAction.attr('id') == 'rtweet') {
        if (window.socialMediaStatuses.twitter === false) {
          return getNextAction(nextAction);
        }
      }
      return nextAction;
    } else {
      return action.next();
    }
  }

  window.nextAction = function(noActions) {
    currentAction = $('.raction-content:visible').parent();
    if (window.Mario) { // hook for Pipeframe
      if ((window.Mario != undefined) && (window.Mario.daisy != undefined)) {
        const stopChain = window.Mario.daisy.apply({ currentActionEl: currentAction, skipped: noActions })
        if (stopChain) return // e.g. for a redirect
      }
    }

    if (noActions) {
      var nextAction = $('.raction');
    }
    else {
      var nextAction = getNextAction(currentAction);
      if (!preventFeedback) {
        $(".feedback-alert", currentAction).show().alert();
        window.setTimeout(function() {
          $(".feedback-alert").alert('close');
        }, 3500);
      }
      else {
        preventFeedback = false;
      }
    }
    if (nextAction.hasClass('redirect')) {
      var redirect_url = $('.js-redirect-url').data('js-redirect-url');

      redirect_url = redirect_url.replace('{name}', $("input[name$='[name]']", currentAction).val());
      redirect_url = redirect_url.replace('{firstname}', $("input[name$='[firstname]']", currentAction).val());
      redirect_url = redirect_url.replace('{lastname}', $("input[name$='[lastname]']", currentAction).val());
      redirect_url = redirect_url.replace('{email}', $("input[name$='[email]']", currentAction).val());
      redirect_url = redirect_url.replace('{postcode}', $("input[name$='[postcode]']", currentAction).val());
      redirect_url = redirect_url.replace('{country}', $("input[name$='[country]']", currentAction).val());

      window.location = redirect_url;
      return;
    }
    else if (nextAction.attr('id') == 'rdonate') {
      if (options["shareOnDonate"]) {
        if (options["skipLoggedOutShareSteps"]) {
          if (!(window.socialMediaStatuses.facebook === false && window.socialMediaStatuses.twitter === false)) {
            $('.js-share-popup').modal({});
          }
        } else {
          $('.js-share-popup').modal({});
        }
      }
    }
    else if (nextAction.attr('id') == 'rshare') {
      if (options["skipLoggedOutShareSteps"]) {
        if (window.socialMediaStatuses.facebook === false) {
          $('.js-facebook-share-container').hide();
        }
        if (window.socialMediaStatuses.twitter === false) {
          $('.js-twitter-share-container').hide();
        }
      }
    }
    if (currentAction) {
      $("input[name$='[name]']", nextAction).val($("input[name$='[name]']", currentAction).val());
      $("input[name$='[firstname]']", nextAction).val($("input[name$='[firstname]']", currentAction).val());
      $("input[name$='[lastname]']", nextAction).val($("input[name$='[lastname]']", currentAction).val());
      $("input[name$='[email]']", nextAction).val($("input[name$='[email]']", currentAction).val());
      $("input[name$='[postcode]']", nextAction).val($("input[name$='[postcode]']", currentAction).val());
      $("input[name$='[country]'],select[name$='[country]']", nextAction).val($("input[name$='[country]'],select[name$='[country]']", currentAction).val());
      $("input[name$='[opt_in]']", nextAction).prop('checked', $("input[name$='[opt_in]']", currentAction).is(':checked'));
      $("input[name='terms_and_conditions']", nextAction).prop('checked', $("input[name='terms_and_conditions']", currentAction).is(':checked'));

      $('.raction-content', currentAction).slideUp();
    }

    // show next action
    nextAction.show();
    $('.raction-content', nextAction).slideDown();

    // Update the body class so global styles can reflect the current action
    // spell these out to keep things search friendly
    var actionClasses = ['action-rsign', 'action-rshare', 'action-rmail', 'action-rtweet', 'action-rfacebook', 'action-rcall', 'action-rcustom', 'action-rpledge', 'action-rdonate', 'action-rthanks', 'action-redirect'];
    window.document.body.classList.remove(...actionClasses);
    window.document.body.classList.add('action-' + nextAction.attr('id'));


    // scroll to top
    window.scrollTo(0, 0);
  }

  window.ractionSetup = function(raction) {
    $('form .form-group').css('margin-bottom', '5px');

    if (options["skippableFirstStep"]) {
      $('a.skip', raction).click(function () {
        preventFeedback = true;
        nextAction(false);
      });
    } else {
      // what is this condition supposed to mean?
      // first button in raction=first on user journey?
      if ($('a.skip', raction)[0] == $('a.skip:first')[0]) {
        $('a.skip', raction).hide();
      } else {
        $('a.skip', raction).click(function () {
          preventFeedback = true;
          nextAction(false);
        });
      }
    }

    if (options["alreadySigned"]) {
      $('.already-signed .btn', raction).click(function() {
        preventFeedback = true;
        nextAction(false);
      });
    }
  };

  /* hide completed fields */
  $(function () {
    $('.raction').hide();

    hide_known_member_data();

    var marginTop = options["campaignImageUrl"] ? '' : 'style="margin-top: 0"';

    $('<h1 ' + marginTop + '>' + options["campaignName"] + '</h1>').prependTo('.raction:eq(0) .advice-container');
    if (options["campaignImageUrl"]) {
      $('<img class="img-responsive" style="width:100%" src="' + options["campaignImageUrl"] + '">').prependTo('.raction:eq(0) .advice-container');
    }
    if (options["hasActionsWithDecisions"]) {
      var action;
      if (options["forceAction"]) {
        action = $('#r' + options["forceAction"]);
      } else {
        action = $('.raction:eq(0)');
      }
      window.document.body.classList.add('action-' + action.attr('id'));
      action.show();
    } else {
      nextAction(true);
    }
  });
}


/*** EXPORTS FROM exports-loader ***/
module.exports = setupActions;